import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthGuard } from '../../guards/auth-guard';

@Component({
    selector: 'logout',
    template: ''
})

export class Logout {
    constructor(private route: ActivatedRoute, public router: Router, private auth: AuthGuard) { }

    ngOnInit() {
        this.auth.logout();
    }
}